import { useAccountInterestWithPrefix } from './useAccountInterest';

function cleanData(responses) {
  if (typeof responses === 'string') {
    return !responses ? '<Empty>' : responses;
  }
  if (Array.isArray(responses)) {
    return responses.length === 0 ? '<Empty>' : responses;
  }
  return Object.keys(responses).reduce((result, key) => {
    const cleanKey = key.replace(/\//g, 'or');
    result[cleanKey] = cleanData(responses[key]);
    return result;
  }, {});
}

function useSurvey(name: string) {
  const state = useAccountInterestWithPrefix(`surveys.${name}`);

  const pending = Object.keys(state.data || {}).length === 0;
  const storeResponses = (input) => state.update.mutate(cleanData(input))

  return { pending, storeResponses };
}

export default useSurvey;
